import { Component, OnInit } from '@angular/core';
import { StepperService } from 'src/app/services/stepper.service';

@Component({
  selector: 'app-recover-password',
  templateUrl: './recover-password.component.html',
  styleUrls: ['../../auth.styles.css']
})
export class RecoverPasswordComponent implements OnInit {

  constructor( public _stepper: StepperService ) { 
    this._stepper.setStepper({
      total: 3,
      current: 1,
      hidden: false
    })
  }

  ngOnInit(): void {
  }

}
